<div class="container" [class]="data.type">
  <div class="icon">
    <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
  </div>

  <div class="content">
    <h3>{{ data.title | translate }}</h3>
    <p>{{ data.message | translate }}</p>
  </div>

  <div class="buttons">
    @if (data.enableCancelBtn) {
      <button class="btn cancel"  (click)="cancel()">
        {{ 'ACTIONS.CANCEL' | translate }}
      </button>
    }
    <button class="btn" (click)="confirm()">
      {{ 'ACTIONS.CONFIRM' | translate }}
    </button>
  </div>
</div>
